import styled from 'styled-components';
import { slide as Burger } from 'react-burger-menu';
import { string, node } from 'prop-types';

import { MAIN_COLOR, WHITE_COLOR, TABLET_SIZE } from '../../constants/index';
import { withI18next } from '../../lib/withI18next';

const StyledSideMenuWrapper = styled.div`
  .bm-menu-wrap {
    top: 0;
  }

  .bm-burger-button {
    position: fixed;
    width: 30px;
    height: 25px;
    top: 52px;
    right: ${({ right }) => (right ? right : '20px')};
  }

  .bm-cross-button {
    height: 24px;
    width: 24px;
    display: ${({ showCustomCross }) => (showCustomCross ? 'none' : 'block')};
  }

  .bm-morph-shape {
    fill: #373a47;
  }

  .bm-overlay {
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    right: 0;
  }

  .bm-burger-bars {
    background: ${({ fontColor }) => fontColor};
  }

  .bm-cross {
    background: ${({ crossButtonColor }) =>
      crossButtonColor ? crossButtonColor : WHITE_COLOR};
  }

  .bm-menu {
    background: ${({ color }) => (color ? color : MAIN_COLOR)};
    padding: 10px;
  }

  @media (max-width: ${TABLET_SIZE}) {
    .bm-menu-wrap {
      width: 80% !important;
    }
  }
`;

const SideMenuWrapper = ({
  fontColor,
  color,
  right,
  children,
  crossButtonColor,
  customBurgerIcon,
}) => {
  return (
    <StyledSideMenuWrapper
      fontColor={fontColor}
      right={right}
      color={color}
      crossButtonColor={crossButtonColor}
    >
      <Burger right customBurgerIcon={customBurgerIcon}>
        {children}
      </Burger>
    </StyledSideMenuWrapper>
  );
};

SideMenuWrapper.propTypes = {
  children: node.isRequired,
  fontColor: string,
  color: string,
  right: string,
  customBurgerIcon: node,
  crossButtonColor: string,
};

export default withI18next()(SideMenuWrapper);



// WEBPACK FOOTER //
// components/SideMenu/SideMenuWrapper.js